import { useState } from "react"

import { useTranslation } from "react-i18next"

import {
  Brain,
  ChevronsUpDown,
  LogOut,
  Megaphone,
  Settings,
  User as UserIcon,
} from "@/components/icons"
import { MemoryPanel } from "@/components/MemoryPanel/MemoryPanel"
import { Avatar } from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function DemoMemoryPanel() {
  const { t } = useTranslation()
  const [showMemory, setShowMemory] = useState(false)

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="bg-sidebar hover:bg-sidebar-accent flex w-fit items-center gap-2 rounded-lg border p-2 text-left text-sm">
          <Avatar className="bg-sidebar-accent flex size-8 items-center justify-center rounded-lg">
            <UserIcon className="size-5" />
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight">
            <span className="truncate font-semibold">Your Name</span>
            <span className="text-muted-foreground truncate text-xs">your.name@email.com</span>
          </div>
          <ChevronsUpDown className="ml-auto size-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56 rounded-lg">
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
              <Avatar className="flex size-8 items-center justify-center rounded-lg">
                <UserIcon className="size-5" />
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">Your Name</span>
                <span className="truncate text-xs">your.name@email.com</span>
              </div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem disabled className="cursor-not-allowed py-2 opacity-50">
            <Settings className="size-5" />
            {t("settingsbutton.settings")}
          </DropdownMenuItem>
          <DropdownMenuItem className="py-2" onClick={() => setShowMemory(true)}>
            <Brain className="size-5" />
            {t("pages.memory.menu")}
          </DropdownMenuItem>
          <DropdownMenuItem disabled className="cursor-not-allowed py-2 opacity-50">
            <Megaphone className="size-5" />
            {t("pages.whats_new.menu")}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem disabled className="cursor-not-allowed py-2 opacity-50">
            <LogOut className="size-5" />
            {t("loginbutton.logout")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <MemoryPanel open={showMemory} onOpenChange={setShowMemory} />
    </>
  )
}
